import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const Content_DE = {
  ki: 'Regelbasiertes System',
  ki_how: 'Genaue Anweisungen werden in Form eines Programms erstellt.',
  ki_data:
    'Wenn das Wort «Apfel» in Verbindung mit einer Zahl grösser als 1 verwendet wird, muss der Plural «Äpfel» verwendet werden.',
  example: 'Beispiel',
  example_text: 'Erkennen von falschem Plural in Texten',
  ml: 'Maschinelles Lernen',
  ml_how:
    'Lösungen werden durch selbständiges Erschliessen von Zusammenhängen aus bereitgestellten Daten erkannt.',
  ml_data: (
    <>
      Ein Apfel liegt auf dem Teller. &mdash; Ich habe 10 Äpfel gekauft. &mdash;
      Von 10 Birnen ist eine Birne faul. &mdash; ...
    </>
  ),
}

export const Difference = ({
  colorMode,
}: {
  colorMode: 'light' | 'dark' | undefined
}) => {
  const { width, height } = useWindowSize()
  const isMobile = width < 712
  if (!isMobile) {
    return (
      <StyledDifference>
        <Container>
          <div>
            <div className='title ai'>
              <span>{Content_DE.ki}</span>
              <div>{Content_DE.ki_how}</div>
            </div>
          </div>
          <div className='center'>
            <div className='title ex'>
              <span>{Content_DE.example}</span>
              <div>{Content_DE.example_text}</div>
            </div>
          </div>
          <div>
            <div className='title ml'>
              <span>{Content_DE.ml}</span>
              <div>{Content_DE.ml_how}</div>
            </div>
          </div>
        </Container>
        <Container className='second'>
          <div>
            <div className='text ai'>
              <b>Regel:</b>
              <br />
              {Content_DE.ki_data}
              <svg width={'77px'}>
                <path d={Arrows.right} />
              </svg>
            </div>
          </div>
          <div className='image'>
            <img src={require('./brain.png')} />
          </div>
          <div>
            <div className='text ml'>
              <b>Bekannte Daten:</b>
              <br />
              {Content_DE.ml_data}
              <svg width={'77px'}>
                <path d={Arrows.left} />
              </svg>
            </div>
          </div>
        </Container>
        <Container className='third'>
          <div></div>
          <div>
            <b>Gefundener Fehler:</b>
            <div className='wrong'>
              «Am Baum hängen 5 <span>Apfel</span>.»
              <div className='correct'>Äpfel</div>
            </div>
          </div>
          <div></div>
        </Container>
      </StyledDifference>
    )
  }
  return (
    <StyledDifferenceMobile colorMode={colorMode}>
      <BG colorMode={colorMode} top={true}>
        <div className='title ai'>
          <span>{Content_DE.ki}</span>
          <div>{Content_DE.ki_how}</div>
        </div>
        <div className='text ai'>
          <b>Regel:</b>
          <br />
          {Content_DE.ki_data}
          <svg height={'73px'}>
            <path d={Arrows.right} fill='var(--brandblue-bright-4)' />
          </svg>
        </div>
      </BG>
      <div className='image'>
        <img src={require('./brain_mob-01.png')} />
      </div>
      <BG colorMode={colorMode}>
        <div>
          <div className='text ml'>
            <b>Bekannte Daten:</b>
            <br />
            {Content_DE.ml_data}
            <svg width={'77px'}>
              <path d={Arrows.top} fill='var(--brandblue-bright-4)' />
            </svg>
          </div>
        </div>
        <div className='title ml'>
          <span>{Content_DE.ml}</span>
          <div>{Content_DE.ml_how}</div>
        </div>
      </BG>
      <div style={{ textAlign: 'center' }}>
        <img className='arrows' src={require('./arrows.png')} />
      </div>
      <div>
        <b>Gefundener Fehler:</b>
      </div>
      <div className='wrong'>
        «Am Baum hängen 5{' '}
        <span>
          Apfel<div className='correct'>Äpfel</div>
        </span>
        .»
      </div>
    </StyledDifferenceMobile>
  )
}

const BG = styled.div<{
  colorMode: 'light' | 'dark' | undefined
  top?: boolean
}>`
  padding: 15px;
  padding-bottom: ${({ top }) => (top ? '20px' : 'unset')};
  border-top-left-radius: ${({ top }) => (top ? '15px' : '0')};
  border-top-right-radius: ${({ top }) => (top ? '15px' : '0')};
  border-bottom-left-radius: ${({ top }) => (top ? '0' : '15px')};
  border-bottom-right-radius: ${({ top }) => (top ? '0' : '15px')};
  background-color: ${({ top }) =>
    top ? 'var(--petrol-main)' : 'var(--purple-main)'};
  position: relative;
  .arrows {
    position: absolute;
    bottom: -100px;
    left: calc(50% - 25px);
  }
`
const StyledDifferenceMobile = styled.div<{
  colorMode: 'light' | 'dark' | undefined
}>`
  overflow: hidden;

  font-family: var(--font-sans-serif);
  line-height: 1.4em;
  margin-bottom: 60px;
  .image {
    padding-top: 10px;
    text-align: center;
    img {
      margin-top: 15px;
      margin-bottom: 15px;
      width: 100%;
      max-width: 160px;
    }
  }
  .title {
    margin-top: 15px;
    margin-bottom: 15px;
    span {
      font-weight: 700;
    }
    &.ai {
      color: #fff;
    }
    &.ml {
      color: #fff;
      padding-bottom: 30px;
    }
  }
  .text {
    position: relative;
    font-weight: 300;
    padding: 15px;
    width: calc(100% - 30px);
    svg {
      position: absolute;
    }
    &.ai {
      background-color: var(--brandblue-bright-4);
      color: var(--brandblue-main);
      svg {
        left: 0px;
        top: 100%;
      }
    }
    &.ml {
      background-color: var(--brandblue-bright-4);

      color: var(--brandblue-main);
      svg {
        left: calc(100% - 77px);
        top: -72px;
      }
    }
  }
  .wrong {
    white-space: nowrap;
    position: relative;
    font-family: monospace;
    font-size: 18px;
    text-align: center;
    border: 2px solid var(--brandblue-bright-4);
    padding: 5px;
    padding-top: 12px;
    margin-top: 10px;
    padding-bottom: 15px;
    span {
      position: relative;
      text-decoration: underline;
      text-decoration-style: wavy;
      text-decoration-color: red;
    }
  }
  .correct {
    position: absolute;
    top: calc(-2em + -30px);
    right: -50%;

    background-color: var(--text-color);
    color: var(--site-background);
    padding: 10px;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: calc(100% - 20px);
      width: 0;
      height: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;

      border-left: 20px solid var(--text-color);
    }
  }
`
const StyledDifference = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 18px;
  line-height: 1.4em;
  margin-bottom: 60px;

  .second {
    margin-bottom: 250px;
  }
  .third {
    .wrong {
      margin-top: 5px;

      white-space: nowrap;
      position: relative;
      font-family: monospace;
      font-size: 18px;
      text-align: center;
      border: 2px solid var(--brandblue-bright-4);
      padding: 5px;
      padding-top: 12px;
      padding-bottom: 15px;
      span {
        text-decoration: underline;
        text-decoration-style: wavy;
        text-decoration-color: red;
      }
    }
    .correct {
      position: absolute;
      top: calc(-2em + -20px);
      right: 0;

      background-color: var(--text-color);
      color: var(--site-background);
      padding: 10px;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: calc(100% - 20px);
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;

        border-left: 20px solid var(--text-color);
      }
    }
  }
  img {
    width: 100%;
    max-width: 300px;
  }
  .title {
    margin-bottom: 30px;
    span {
      display: inline-block;
      font-weight: 700;
    }
    &.ai {
      padding-top: 4em;
      text-align: right;
      color: var(--petrol-main);
    }
    &.ml {
      padding-top: 4em;
      text-align: left;
      color: var(--purple-main);
    }
    &.ex {
      padding-left: 30px;
      padding-right: 30px;
      text-align: center;
      color: var(--text-color);
      font-weight: 700;
      span {
        font-weight: 300;
      }
    }
  }
  .text {
    position: relative;
    font-weight: 200;
    padding: 15px;
    height: calc(100% - 30px);
    svg {
      position: absolute;
    }
    &.ai {
      background-color: var(--petrol-main);
      color: #fff;
      svg {
        left: calc(100% - 30px);
        top: 100%;
        path {
          fill: var(--petrol-main);
        }
      }
    }
    &.ml {
      background-color: var(--purple-main);
      color: #fff;
      svg {
        left: -47px;
        top: 100%;
        path {
          fill: var(--purple-main);
        }
      }
    }
  }
  .image {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    img {
      position: absolute;
      top: 100%;
    }
  }
`
const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  div {
    flex: 0 0 33.3333%;
  }
  @media only screen and (max-width: 711px) {
    flex-wrap: wrap;
    div {
      flex: 0 0 100%;
    }
  }
`

const Arrows = {
  right:
    'M77.1382,62.0135l-10.6838-10.6838v8h-3.4409C28.2121,59.3297,30,29.9598,30,0H0C0,34.8014,28.2121,64.6973,63.0135,64.6973h3.4409v8l10.6838-10.6838Z',
  left: 'M47.1382,0c0,29.9597,1.7879,59.3296-33.0135,59.3296h-3.4409v-8L0,62.0134l10.6838,10.6838v-8h3.4409c34.8014,0,63.0135-29.8959,63.0135-64.6973h-30Z',
  top: 'M47.1382,72.6973c0-29.9597,1.7879-59.3296-33.0135-59.3296h-3.4409v8S0,10.6838,0,10.6838L10.6838,0V8h3.4409c34.8014,0,63.0135,29.8959,63.0135,64.6973h-30Z',
}
